// import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AgentNotifications from "../../components/AgentStudio/AgentNotifications";
// import swal from "sweetalert";

function Register() {
  // const navigate  = useNavigate();
  // const logoutSubmit = (e) => {
  //     e.preventDefault();

  //     axios.get('/sanctum/csrf-cookie').then(response => {
  //             axios.post(`/api/logout`).then(res => {
  //                 if(res.data.status === 200){
  //                     localStorage.removeItem('auth_token', res.data.token);
  //                     localStorage.removeItem('auth_name', res.data.username);
  //                     swal("Success",res.data.message,"success");
  //                     navigate('/login');
  //                 }
  //             });
  //     });
  // };

  // var AuthButton = '';
  // if(!localStorage.getItem('auth_token')){
  //     AuthButton = (
  //         <ul className="navbar- nav">
  //             <li className="nav-item">
  //                 <Link className="nav-link" style={{color: 'white'}} to="/login">Login</Link>
  //             </li>
  //             <li className="nav-item">
  //                 <Link className="nav-link" style={{color: 'white'}} to="/register">Register</Link>
  //             </li>
  //         </ul>
  //     )
  // } else {
  //     AuthButton = (
  //             <li className="nav-item">
  //                 <Link className="btn btn-danger" onClick={logoutSubmit} to="/logout">Log-Out</Link>
  //             </li>
  //     )
  // }
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

  useEffect(() => {
    if (theme === 'dark') {
      document.body.setAttribute('data-theme', 'dark');
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.body.removeAttribute('data-theme');
      document.documentElement.removeAttribute('data-theme');
    }
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  return (
    <nav className="primary-header d-flex justify-content-between align-items-center">
      <div className="d-flex align-items-center">
        <button
        type="button"
        className="btn btn-icon dark menu-toggle"
        onClick={(e) => {
          document.body.classList.add("menu-open");
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M4 8l16 0" />
          <path d="M4 16l16 0" />
        </svg>
      </button>
      <Link className="brand" to="/">
        <img src="/assets/images/logo-white.svg" alt="Native Metrics" />
      </Link>
      </div>

      <div className="header-actions" style={{marginRight: "20px", display: "flex", alignItems: "center"}}>
        <AgentNotifications />
        <button 
          onClick={toggleTheme} 
          className="btn btn-icon theme-toggle-btn" 
          style={{color: "white", background: "rgba(255,255,255,0.1)", borderRadius: "50%", width: "36px", height: "36px", display: "flex", alignItems: "center", justifyContent: "center", border: "none", cursor: "pointer", transition: "all 0.3s ease"}}
          title="Toggle Dark/Light Mode"
        >
          {theme === 'light' ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>
          )}
        </button>
      </div>
    </nav>
  );
}
export default Register;
